module.exports = __webpack_public_path__ + "media/images/icons/Apple-9e10418850b667acead3046c799aea26.svg";